// this is an autogenerated file from DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/SendDocumentModal/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_PreviewDocumentModal_Content_Content_HtmlFile_Content_Content_Content_Footer_SendDocumentModal_Content($document_id: StringOrNumber!) {
  vaxiom_transform_html_document_to_pdf(document_id: $document_id) {
    ok
  }
}

`